import React from 'react';
import styled from 'styled-components';

import * as colors from '../utils/colors';

const berlinIsHome = game => game.home_away === 'Home';

const isForBerlin = item => !item.playerName;

const scoreFor = (item, game) => {
  const forBerlin = isForBerlin(item);
  const isHome = berlinIsHome(game);
  if ((forBerlin && isHome) || (!forBerlin && !isHome)) return 'home';
  if ((forBerlin && !isHome) || (!forBerlin && isHome)) return 'visitor';
};

const teamInfo = (game, forBerlin) => {
  const isHome = berlinIsHome(game);
  if (forBerlin) return game[isHome ? 'home' : 'visitor'];
  return game[!isHome ? 'home' : 'visitor'];
}

const GameWrapper = styled.section`
  display: flex;
  align-items: center;
  margin: 20px 0;

  .display {
    font-size: 3em;
    display: flex;
  }

  .splitter {
    margin-left: 5px;
    margin-right: 5px;
  }

  .meta {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .display {
    margin-top: 15px;
  }

  .location,
  .contest {
    margin-top: 5px;
  }

  .location,
  .contest {
    font-family: KlavikaMedium;
  }

  .location {
    color: ${colors.ebbRed};
  }

  .date {
    margin-top: 3px;
  }

  .logo {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 90px;
    height: 90px;
    margin:0 auto 10px auto;
  }

  .team {
    align-self: flex-start;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    max-width: 33%;
    min-width: 33%;

    .name {
      font-size: 1.2rem;
      font-family: KlavikaMedium;
      text-align: center;
      flex-grow: 1;
    }

    &.visitor {
    }
  }
`;

const PresentedBy = styled.div`
  display: flex;
  color: ${colors.white};
  border-bottom: 1px solid currentColor;
  margin: 0 auto 2rem auto;
  align-items: center;
  justify-content: center;

  .presented-by-inner {
    display: flex;
    align-items: end;
    justify-content: stretch;
    background-color: ${colors.bg};
    margin-bottom: -0.7rem;
    max-height: 1.4rem;
  }

  span,
  img {
    margin: 0;
    max-height: 1.4rem;
    margin-right: 0.5rem;
  }

  span {
    font-size: 0.9rem;
    margin-left: 0.5rem;
    margin-top: 2px;
  }
`;

export default class Game extends React.Component {
  mounted = false;

  componentDidMount() {
    this.mounted = true;
    if (typeof window === 'undefined') return;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    return (
      <React.Fragment>
        <GameWrapper className="top-game">
          <div className="team home">
            <div className="logo home" />
            <div className="name home" />
          </div>

          <div className="meta">
            <div className="display colossalis">
              <div className="score home">0</div>
              <div className="score splitter">:</div>
              <div className="score visitor">0</div>
            </div>
            <div className="location" />
            <div className="contest" />
            <div className="date" />
          </div>

          <div className="team visitor">
            <div className="logo visitor" />
            <div className="name visitor" />
          </div>
        </GameWrapper>

        <PresentedBy className="presented-by">
          <div className="presented-by-inner">
            <span>
              präsentiert von
            </span>

            <img alt="sponsor" />
          </div>
        </PresentedBy>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/game.js